import { Theme } from "@mui/material";

export const getSocialsStyles = (theme: Theme) => ({
  fontSize: 0,
  "& svg": {
    fill: theme.palette.grey[600],
    transition: "all 250ms ease-out",
  },
  "&:hover svg": {
    fill: theme.palette.primary.main,
  },
  "&:focus svg": {
    fill: theme.palette.primary.main,
  },
});

export const getSocialsFooterStyles = () => ({
  fontSize: 0,
  "& svg g  path": {
    fill: "#fff"
  },
  "&:hover svg g  path": {
    fill: "#FF6B00",
  },
});
